import React from "react";
import { get, map, sortBy, filter } from "lodash";

import Grid from "@material-ui/core/Grid";

import InfoSection from "../../Common/InfoSection";

import { getAttributeValue } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";
import { displayBoolean } from "../../../utils/data";

const GenericView = (props) => {
  const { section, data, lov, language, profileAttributes } = props;

  const mainAttributes = sortBy(
    filter(
      profileAttributes,
      (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
    ),
    (attr) => get(attr, ["app_display_seq_numb"])
  );
  const secondaryAttributes = sortBy(
    filter(
      profileAttributes,
      (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
    ),
    (attr) => get(attr, ["app_display_seq_numb"])
  );

  const attributes = section === "main" ? mainAttributes : secondaryAttributes;

  return (
    <Grid container>
      {map(attributes, (attr) => {
        return attr.id===135?null:<InfoSection
          key={attr.id}
          style={{ width: "220px" }}
          title2={getAttributeName(attr.id)}
          values={[
            attr.data_type === "boolean"
              ? displayBoolean(getAttributeValue(data, attr.id, lov, language))
              : getAttributeValue(data, attr.id, lov, language),
          ]}
        />
        })}
    </Grid>
  );
};

export default GenericView;
